import { MouseEventHandler } from "react";
import RedirectButton from "./RedirectButton"

interface LandingButtonProps {
    onClick?: MouseEventHandler
}

function LandingButton ({ onClick }: LandingButtonProps) {
    return (
        <div className="button-container nav-bar-item">
            <RedirectButton display='Cards Demo' url='/' className='btn' onClick={onClick} />
        </div>
    )
}

export default LandingButton